<template>
  <span class="sh-table-column-format">
    <slot v-if="!!$slots.default"></slot>
    <template v-else>
      <span v-if="value === null || value === undefined">-</span>
      <!-- 数字千分位 -->
      <span v-else-if="type === 'point'">{{ value | formatPoint }}</span>
      <!-- 千分位 - 整数 -->
      <span v-else-if="type === 'point-int'">
        {{ parseInt(value) | formatPoint }}
      </span>
      <!-- 千分位 - 保留2位小数,四舍五入，如果为0显示空 -->
      <span v-else-if="type === 'point-part'">
        {{ value | formatCurrencyPoint(2) }}
      </span>
      <!-- 千分位 - 取整,四舍五入，如果0不显示 -->
      <span v-else-if="type === 'point-int1'">
        {{ (Math.round(value) || '-') | formatPoint }}
      </span>
      <!-- 千分位 - 取整,四舍五入，如果为0显示 -->
      <span v-else-if="type === 'point-int2'">
        {{ Math.round(value) | formatPoint }}
      </span>
      <!-- 百分比：小数转百分比 (四舍五入) -->
      <span v-else-if="type === 'percentage'"> {{ value | formatPercentage }}% </span>
      <!-- 百分比：小数转百分比 (非四舍五入) -->
      <span v-else-if="type === 'percentageNo'"> {{ value | formatPercentageNo }}% </span>
      <!-- 千分位，四舍五入，两位小数，0显示 -->
      <span v-else-if="type === 'price-float1'"> {{ value | formatCurrency }} </span>
      <span v-else>{{ value }}</span>
    </template>
  </span>
</template>

<script>
import filter from '../../../utils/filter'
export default {
  name: 'ShTableColumnFormat',
  props: {
    value: [String, Number, Boolean],
    type: {
      type: String,
      default: 'string'
    }
  },
  filters: {
    ...filter
  }
}
</script>

<style></style>
